import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=a2f1abfe&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=a2f1abfe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f1abfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f1abfe')) {
      api.createRecord('a2f1abfe', component.options)
    } else {
      api.reload('a2f1abfe', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=a2f1abfe&scoped=true", function () {
      api.rerender('a2f1abfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/orderDetail/orderDetail.vue"
export default component.exports